/**
 * Storing the current Feedback Status Type property options
 */
const FeedbackStatusTypes = {
	O: "Outstanding",
	C: "Complete",
};

export default FeedbackStatusTypes;
